export default __webpack_public_path__ + "static/media/Group717.ff4a0d38.svg";